import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "license-page-header" }
const _hoisted_2 = { class: "license-page-header__tabs" }
const _hoisted_3 = { class: "license-page-header__actions" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _renderSlot(_ctx.$slots, "tabs")
    ]),
    _createElementVNode("div", _hoisted_3, [
      _renderSlot(_ctx.$slots, "download"),
      _renderSlot(_ctx.$slots, "upload"),
      _renderSlot(_ctx.$slots, "update")
    ])
  ]))
}